<template>
  <div class="benefits">
    <div class="benefits-banner">
      <h3>{{pageTitle}}</h3>
    </div>
    <div class="main-benefits" v-if="!showCampusDetails && !showLearning">
      <ul>
        <li v-for="(benefit, i) in benefits" v-bind:key="i" v-on:tap="goTo(benefit.link.url)">
          <div class="title">{{benefit.title}}</div>
          <div class="info">
            <div class="info-link link">{{benefit.link.text}}</div>
            <!-- <div class="info-icon-container">
              <IconInfo />
            </div>-->
          </div>
        </li>
      </ul>
    </div>
    <transition name="slide-right" mode="out-in">
      <div class="campus" v-if="showCampusDetails">
        <div>
          <div class="group">
            <div class="title">Convenzione Campus Bio medico</div>
            <div class="link">Programmi check-up gratuiti</div>
          </div>
          <div class="group">
            <div class="list-title">Check-up ginecologico donna</div>
            <ul>
              <li>- Visita ginecologica</li>
              <li>- Pap test</li>
              <li>- Ecografia transvaginale</li>
              <li>- Ecografia mammaria bilaterale (per donne di età &lt; 40 anni)</li>
              <li>- Mammografia bilaterale (per donne di età &gt; 40 anni)</li>
            </ul>
          </div>
          <div class="group">
            <div class="list-title">Check-up cardiovascolare</div>
            <ul>
              <li>- Emocromo completo</li>
              <li>- Glicemia</li>
              <li>- Colesterolo HDL</li>
              <li>- Colesterolo LDL</li>
              <li>- Colesterolo totale</li>
              <li>- Trigliceridi</li>
              <li>- Visita cardiologica</li>
              <li>- Elettrocardiogramma</li>
              <li>- Test da sforzo</li>
              <li>- Ecocolordoppler dei tronchi sovraortici</li>
              <li>- Ecocardiogramma</li>
            </ul>
          </div>
          <div class="group">
            <div class="list-title">Check-up allergie</div>
            <ul>
              <li>- Prick test per alimenti</li>
              <li>- Prick test per inalanti</li>
              <li>- Patch test serie standard</li>
              <li>- Visita specialistica allergolocica</li>
            </ul>
          </div>
          <div class="group">
            <div class="list-title">Check-up allergie alimentari</div>
            <ul>
              <li>- Prick test</li>
              <li>- Prick test per alimenti</li>
              <li>- Visita di nutrizione clinica</li>
              <li>- Visita specialistica allergolocica</li>
            </ul>
          </div>
          <div class="group">
            <div class="list-title">Check-up allergie respiratorie</div>
            <ul>
              <li>- Prick test per inalanti</li>
              <li>- Spirometria semplice</li>
              <li>- Visita specialistica otorinolaringoiatrica</li>
              <li>- Visita specialistica allergologica</li>
            </ul>
          </div>
          <div class="group">
            <div class="list-title">Check-up tiroideo</div>
            <ul>
              <li>- Esami ematici (TSH, FT4, anticorpi anti-tireoperossidasi, calcitonina)</li>
              <li>- Ecografia tiroidea con eventuale agoaspirato (in caso di necessità clinica)</li>
              <li>- Visita specialistica endocrinologica</li>
            </ul>
          </div>
          <div class="group">
            <div class="list-title">Check-up base</div>
            <ul>
              <li>- Esami ematici (GOT o AST, GPT o ALT, azotemia, bilirubina totale, colesterolo totale, HDL e LDL, creatinina, elettroforesi sieroproteica, emocromo, fibrinogeno funzionale, glicemia, proteine totali, tempo di protrombina, tempo di tromboplastina parziale o aPTT, trigliceridi, ferritina, PCR, PSA solo per l’uomo e TSH solo per la donna)</li>
              <li>- Esame delle urine</li>
              <li>- Elettrocardiogramma</li>
              <li>- Ecografia addominale completa</li>
              <li>- Visita internistica conclusiva</li>
            </ul>
          </div>
        </div>

        <div>
          <div class="group">
            <div class="title">Modalità di prenotazione</div>
          </div>
          <div class="group">
            <div class="group-text group-text-custom">
              <div>Per le prenotazioni contattare l’Ufficio Convenzioni e Check-up del Campus Bio medico attivo dal lunedì al venerdì, ore 8:00 – 17.30:</div>
              <br />
              <div>
                Tel.:
                <a href="tel:+3906225411485">(+39) 06.22541.1485</a>
              </div>
              <div>
                email:
                <a href="mailto:checkup@unicampus.it">checkup@unicampus.it</a>
              </div>
              <br />
              <div>All’arrivo al Policlinico il dipendente dovrà mostrare un documento e il tesserino identificativo della società.</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="learning" v-if="showLearning">
      <div>
        <div
          class="group flex-group"
          v-on:tap="goTo('https://sites.google.com/view/rds-learning/workshop')"
        >
          <div class="title grow">Workshop:</div>
          <div class="info-icon-container">
            <IconInfo />
          </div>
        </div>
        <div class="group">
          <div
            class="group-text box-learning"
          >Qui potrai rivivere tutti i workshop organizzati nel nostro auditorium o, qualora te ne fossi perso qualcuno, potrai accedere ai video e agli altri documenti senza problemi!</div>
        </div>
      </div>

      <div>
        <div
          class="group flex-group"
          v-on:tap="goTo('https://sites.google.com/view/rds-learning/soft-skills')"
        >
          <div class="title grow">Soft Skills:</div>
          <div class="info-icon-container">
            <IconInfo />
          </div>
        </div>
        <div class="group">
          <div
            class="group-text box-learning"
          >Se hai il desiderio di approfondire il tema delle soft skills e tutti quelli che sono i nostri valori, ti basterà andare in questa sezione e scoprire cosa significa lo Stile, la Passione, l’Empatia, il Cambiamento e l’Innovazione in RDS con il supporto di alcune clip di film/cartoni ed altri documenti!</div>
        </div>
      </div>
      <div>
        <div
          class="group flex-group"
          v-on:tap="goTo('https://sites.google.com/view/rds-learning/mooc?authuser=0')"
        >
          <div class="title grow">Mooc:</div>
          <div class="info-icon-container">
            <IconInfo />
          </div>
        </div>
        <div class="group">
          <div
            class="group-text box-learning"
          >Ecco la sezione dedicata ai Mooc! I MOOC (Massive Online Open Course) sono corsi di formazione online gratuiti aperti a chiunque e accessibili da qualunque parte del mondo attraverso una connessione a Internet.</div>
        </div>
      </div>
      <div>
        <div
          class="group flex-group"
          v-on:tap="goTo('https://sites.google.com/view/rds-learning/suggerimenti?authuser=0')"
        >
          <div class="title grow">Suggerimenti:</div>
          <div class="info-icon-container">
            <IconInfo />
          </div>
        </div>
        <div class="group">
          <div
            class="group-text box-learning"
          >Ti piacerebbe trovare altre tipologie di contenuti o approfondire qualche argomento in particolare? Vorresti suggerire un libro che hai letto e trovato interessante?</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '../config';
import IconInfo from '../assets/images/link_info.svg?inline';
import { eventBus } from '../services/EventBus';
export default {
  name: 'Benefits',
  components: {
    IconInfo
  },
  data() {
    return {
      benefits: config.benefits
    };
  },
  computed: {
    pageTitle() {
      let title = 'CONVENZIONI E BENEFITS';
      if (this.$route.path === '/e-learning') {
        title = 'RDS LEARNING';
      }
      return title;
    },
    showCampusDetails() {
      if (this.$route.path === '/campus-biomedico') {
        eventBus.$emit('showBackButton');
      } else {
        eventBus.$emit('hideBackButton');
      }
      return this.$route.path === '/campus-biomedico';
    },
    showLearning() {
      return this.$route.path === '/e-learning';
    }
  },
  methods: {
    goTo(route) {
      if (route.indexOf('http') === 0) {
        if (window.cordova) {
          // window.cordova.InAppBrowser.open(route, '_system');
          window.cordova.InAppBrowser.open(route, '_blank');
        } else {
          window.open(route, '_blank');
        }
        // window.open(route, '_blank');
        // window.location.href = route;
      } else {
        this.$router.push(route);
      }
    },
    backButtonClicked() {
      this.goTo('/benefits');
    }
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('Benefits back');
      this.backButtonClicked();
    });
  },
  destroyed() {
    eventBus.$emit('hideBackButton');
    eventBus.$off('backButtonClicked');
  }
};
</script>
<style lang="scss" scoped>
.benefits {
  margin: 0 20px;
  padding: 0 0 50px 0;
}
.link {
  color: rgba(38, 48, 159, 0.94);
  font-size: 0.86em;
  font-weight: 600;
}
.benefits-banner {
  height: 163px;
  border-radius: $default-border-radius;
  background-image: url('../assets/images/background_learning.png');
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  h3 {
    color: #ffffff;
    letter-spacing: $default-letter-spacing;
    font-size: 0.95em;
    font-weight: 500;
  }
}
.main-benefits li {
  line-height: 25px;
  background-color: #ffffff;
  border-radius: $default-border-radius;
  letter-spacing: $default-letter-spacing;
  margin-top: 21px;
  padding: $default-padding;
  .title {
    font-weight: 600;
    margin-bottom: 10px;
    width: 85%;
  }
  .info {
    display: flex;
    align-items: center;
  }
  .info-link {
    flex-grow: 1;
    font-size: 0.82em;
  }
}
.info-icon-container {
  // background-color: #3093dc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3093dc;
  width: 25px;
  height: 25px;
  border: 3px solid #ffffffc2;
  svg {
    fill: white;
  }
}
.campus > div,
.learning > div {
  margin-top: 21px;
  background-color: #ffffff;
  padding: $default-padding;
  border-radius: $default-border-radius;
  letter-spacing: $default-letter-spacing;
  .group {
    padding: 0px 0 20px 0;
    line-height: 30px;
    @include dotted-bottom;
    &:after {
      width: 105%;
      left: -3%;
    }
    &:nth-last-child(1) {
      &::after {
        content: none;
      }
    }
    .title {
      font-weight: 600;
    }
    .list-title {
      margin-bottom: 10px;
      margin-top: 20px;
      font-size: 0.86em;
      font-weight: 600;
    }
    li,
    .group-text {
      color: #607d8b;
      font-size: 0.86em;
    }
    .box-learning {
      margin: 20px 0 0 0;
    }
    .group-text-custom {
      margin: 20px 0 0px 0;
      a {
        text-decoration: none;
        color: #607d8b;
      }
    }
    .group-text-custom div {
      line-height: 21px;
    }
    &.flex-group {
      display: flex;
    }
  }
  ul {
    list-style: none;
    text-indent: -11px;
    margin-left: 11px;
  }
}
</style>
